import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AffiliateAdminManageCharterDisplayComponent } from './affiliate-admin-manage-charter-display.component';

@NgModule({
  declarations: [AffiliateAdminManageCharterDisplayComponent],
  exports: [AffiliateAdminManageCharterDisplayComponent],
  imports: [CommonModule],
})
export class AffiliateAdminManageCharterDisplayModule {}
